import { IdentifiersToYmGoalsIdMap } from '../../constants/IdentifiersToYmGoalsIdMap';
import YmSendGoal from '../../helpers/YmSendGoal';

export class YmElements {
    init() {
        this.#addEventListeners();
    }

    #addEventListeners() {
        Object.entries(IdentifiersToYmGoalsIdMap).forEach(([key, value]) => {
            document
                .querySelector(key)
                .addEventListener('click', this.#onTargetClick(value));
        });
    }

    // eslint-disable-next-line class-methods-use-this
    #onTargetClick(ymGoalId) {
        return () => {
            YmSendGoal(ymGoalId);
        };
    }
}
